import { Card, Form, Select } from "antd";

import { SelectOption } from "../types";
import CheckboxField from "./CheckboxField";

interface AccessControlsSectionProps {
  allowCc: boolean;
  locationOptions: SelectOption[];
  showLocationsOverview: boolean;
  showCreateOrder: boolean;
  showStationsOverview: boolean;
  showKdsView: boolean;
  hasStations: boolean;
  hasKdsStations: boolean;
}

// The Access Controls settings, preserving the AngularJS reveal nesting: the quick-order
// location, seated-groups, and create-order controls only appear under "Locations View";
// the card controls only appear under "Allow Create Orders"; the KDS options only appear
// under "KDS View".
const AccessControlsSection = ({
  allowCc,
  locationOptions,
  showLocationsOverview,
  showCreateOrder,
  showStationsOverview,
  showKdsView,
  hasStations,
  hasKdsStations,
}: AccessControlsSectionProps) => (
  <Card title="Access Controls" type="inner">
    <CheckboxField name="show_locations_overview" label="Locations View" />
    {showLocationsOverview && (
      <div style={{ paddingLeft: 16 }}>
        <Form.Item
          name="quick_order_location"
          label="Quick Order Location"
          tooltip="If set, will show the new Quick Order mode UI"
        >
          <Select id="dp-quick-order-location" allowClear placeholder="None" options={locationOptions} />
        </Form.Item>
        <CheckboxField
          name="hide_seated_groups"
          label="Hide Seated Groups"
          tooltip="Hide all references to Seated Groups and # of Guests on Terminal (3.2+)"
        />
        <CheckboxField name="show_create_order" label="Allow Create Orders" />
        {showCreateOrder && (
          <div style={{ paddingLeft: 16 }}>
            <CheckboxField
              name="use_stripe_chip_reader"
              label="Has Stripe Terminal"
              disabled={!allowCc}
              tooltip={allowCc ? undefined : "Stripe Terminal is currently only supported for US Customers"}
            />
            <CheckboxField
              name="allow_manual_card_entry"
              label="Allow Manual CC Entry"
              disabled={!allowCc}
              tooltip={allowCc ? undefined : "Manual CC Entry is currently only supported for US Customers"}
            />
            <CheckboxField
              name="allow_pay_with_consumer_tab"
              label="Allow Tab Sync"
              tooltip="Allows staff to create tabs and place orders on tabs opened by patrons. (Terminal 2.8+)"
            />
          </div>
        )}
      </div>
    )}
    <CheckboxField
      name="show_stations_overview"
      label="Stations View"
      warning={showStationsOverview && !hasStations ? "Warning: No Stations Selected!" : undefined}
    />
    <CheckboxField
      name="show_kds_view"
      label="KDS View"
      warning={showKdsView && !hasKdsStations ? "Warning: No KDS Stations Selected!" : undefined}
    />
    {showKdsView && (
      <div style={{ paddingLeft: 16 }}>
        <CheckboxField name="kds_edit_item_status" label="KDS Edit Item Status" />
        <CheckboxField name="show_order_control" label="Order Control" />
        <CheckboxField name="kds_show_prices" label="Show Itemized Prices and Totals" />
        <CheckboxField name="kds_partial_refunds" label="Allow Partial Refunds" />
        <CheckboxField
          name="kds_group_related_tickets"
          label="Group Related Tickets"
          tooltip="Groups Related Tickets on the KDS View (for expediter stations). Grouped tickets can be expanded. (Terminal 3+)"
        />
      </div>
    )}
    <CheckboxField name="show_menu_editor" label="Menu Editor" />
    <CheckboxField name="show_tip_report" label="Tip Report" />
  </Card>
);

export default AccessControlsSection;
